import { useState } from 'react';
import ProductionTagSelect, {
  MODES,
  type Mode,
  type Tag,
} from 'components/ProductionTagSelect';

const FooBarCaterings = () => {
  const [mode, setMode] = useState<Mode>(MODES.or);
  const [tags, setTags] = useState<Tag['value'][]>([]);

  return (
    <ProductionTagSelect
      selectedTags={tags}
      selectedMode={mode}
      onChange={(newMode, newSelectedTags) => {
        setMode(newMode);
        setTags(newSelectedTags);
      }}
    />
  );
};

export default FooBarCaterings;
